import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  onDeletePageList = () => {
    const {
      openRemovePageTranslationModal
    } = this.props.metadata.customComponentMetadata;
    const uid = this.props.rowData.uid;
    openRemovePageTranslationModal(uid);
  };

  onEditPageList = () => {
    const {
      openEditPageTranslationModal
    } = this.props.metadata.customComponentMetadata;
    const pageUID = this.props.rowData.pageUID;
    openEditPageTranslationModal(pageUID);
  };

  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.onEditPageList}>edytuj</a>
              <br />
              <a onTouchTap={this.onDeletePageList}>usuń</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

class DataComponent extends Component {
  render() {
    return (
      <span>{moment(new Date(this.props.data)).format("DD.MM.YYYY")}</span>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onRowClick = (row, e) => {
    if (e.target.className !== "icon-table link") {
      const { history, params: { slug } } = this.props;
      history.pushState(
        "/pagesLists/:slug/:uid",
        `/pagesLists/${slug}/${row.props.data.uid}`,
        {}
      );
    }
  };

  onChangeSort = field => {
    if (field === "name") {
      const {
        actions,
        notificationSystem,
        pagesLists: {
          pagesLists: {
            search: pagesListsSearch,
            meta: pagesListsMeta,
            sort: pagesListsSort
          }
        }
      } = this.props;
      if (field === "when") {
        field = "whenOccured";
      }
      actions.setPagesListsPaginationPage(0);
      let isDirectionAscending = pagesListsSort.isDirectionAscending;
      if (field === pagesListsSort.field) {
        isDirectionAscending = !isDirectionAscending;
      }
      actions.setSortPagesLists(field, isDirectionAscending);
      actions
        .getPagesLists(pagesListsMeta, pagesListsSort)
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
    }
  };

  removePageTranslation = () => {
    const {
      actions,
      notificationSystem,
      pageTranslations: { pageTranslations: { isRemoveModalVisible } },
      params: { slug },
      pagesLists: { pagesLists: { singleListMeta, search, sort } }
    } = this.props;
    actions
      .removePagesTranslation(isRemoveModalVisible)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          let notification = {
            level: "success",
            message: "Usunięto wpis!",
            position: "br",
            autoDismiss: 5,
            dismissible: true
          };
          notificationSystem.addNotification(notification);
          actions
            .getPagesListBySlug(slug, singleListMeta, search, sort)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        }
      });
    actions.setIsRemovePageTranslationModalVisible(false);
  };

  openRemovePageTranslationModal = uid => {
    const { actions } = this.props;
    actions.setIsRemovePageTranslationModalVisible(uid);
  };

  closeRemovePageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsRemovePageTranslationModalVisible(false);
  };

  updatePageTranslation = () => {
    const {
      actions,
      notificationSystem,
      pageTranslations: { pageTranslations: { isEditModalVisible } },
      pagesLists: {
        pagesLists: { entities: pagesLists, singleListMeta, search, sort }
      },
      params: { slug },
      locales: { locales: { defaultLocale } }
    } = this.props;
    const data = {
      name: pagesLists.getIn([
        slug,
        "pages",
        isEditModalVisible,
        "pageTranslations",
        defaultLocale,
        "name"
      ])
    };
    const uid = pagesLists.getIn([
      slug,
      "pages",
      isEditModalVisible,
      "pageTranslations",
      defaultLocale,
      "uid"
    ]);
    actions.updatePagesTranslation(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions
          .getPagesListBySlug(slug, singleListMeta, search, sort)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
      }
    });
    actions.setIsEditPageTranslationModalVisible(false);
  };

  openEditPageTranslationModal = uid => {
    const { actions } = this.props;
    actions.setIsEditPageTranslationModalVisible(uid);
  };

  closeEditPageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsEditPageTranslationModalVisible(false);
  };

  render() {
    const {
      config,
      actions,
      tableWidth,
      tableHeight,
      pagesLists: {
        pagesLists: {
          loading,
          entities: pagesLists,
          singleListMeta: { currentPage, limit },
          sort
        }
      },
      params: { slug },
      locales: { locales: { defaultLocale } },
      pageTranslations: {
        pageTranslations: {
          isRemoveModalVisible,
          isEditModalVisible,
          entities: pageTranslations
        }
      }
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "createdAt",
        displayName: "Data dodania",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DataComponent
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemovePageTranslationModal: this.openRemovePageTranslationModal,
          openEditPageTranslationModal: this.openEditPageTranslationModal
        }
      }
    ];

    let data = [];
    let index = 0;

    if (pagesLists.getIn([slug, "pages"]) && !loading) {
      pagesLists
        .getIn([slug, "pages"])
        .sort(
          (a, b) =>
            new Date(b.get("createdAt")).getTime() -
            new Date(a.get("createdAt")).getTime()
        )
        .forEach(function(pageItem) {
          let page = pageItem.getIn(["pageTranslations", defaultLocale]).toJS();
          page.pageUID = pageItem.get("uid");
          index++;
          page.index = index + currentPage * limit;
          data = data.concat(page);
        });
    }

    const inputCustomProps = {
      feature: "pagesLists",
      actions: actions,
      entity: pagesLists.getIn([slug]),
      uid: slug
      // placeholder: field.get('placeholder')
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "name", "createdAt", "actions"]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          useExternal={true}
          externalChangeSort={this.onChangeSort}
          externalSortColumn={sort.field}
          externalSortAscending={sort.isDirectionAscending}
          externalSetPage={() => {}}
          externalSetFilter={() => {}}
          externalSetPageSize={() => {}}
          externalMaxPage={() => {}}
          externalCurrentPage={() => {}}
          noDataMessage={loading ? "trwa ładowanie danych..." : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />
        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemovePageTranslationModal}
            enterAction={this.removePageTranslation}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Uwaga!</h3>
              <p>Czy na pewno usunąć?</p>
              <button className="error" onTouchTap={this.removePageTranslation}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeRemovePageTranslationModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditPageTranslationModal}
            enterAction={this.updatePageTranslation}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Edytuj tytuł wpisu</h3>
              <InputCustom
                field={[
                  "pages",
                  isEditModalVisible,
                  "pageTranslations",
                  defaultLocale,
                  "name"
                ]}
                {...inputCustomProps}
              />
              <button className="error" onTouchTap={this.updatePageTranslation}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeEditPageTranslationModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pagesList/table.react.js